import { NextPage } from 'next';
import { getDataFromTree } from '@apollo/client/react/ssr';
// Hoc
import withApollo from 'hocs/withApollo';
// Context
import { FiltersProvider } from 'components/common3/PageWithFiltersWrapper/PageWithFiltersContext';
// Types
import { SortDirection, StoresOrderBy } from 'api/graphql-global-types';
// Layouts
import Header from 'layouts/Header/Header';
import Footer from 'layouts/Footer/Footer';
// Components
import AppBannerAndModal from 'components/common3/AppBannerAndModal/AppBannerAndModal';
import AthletesContainer from 'components/Athletes/Athletes';
import PageBanner from 'components/common3/PageBanner/PageBanner';
// Helpers
import { getEnvLink } from 'helpers/routes';

const Athletes: NextPage = () => {
  const bannerImage = `${getEnvLink()}${'/images/page-banner-images/talent.png'}`;

  return (
    <>
      <AppBannerAndModal when variant="join" />
      <Header />
      <PageBanner title="Athletes" imageUrl={bannerImage} />

      <FiltersProvider
        searchKey="searchTerm"
        hideStoreFilter={false}
        hideOrganizationsFilter
        hideContentCreatorsFilter
        hideAthletesFilter
        initialSorting={{
          direction: SortDirection.DESC,
          order: StoresOrderBy.socialFollowerCount,
        }}
      >
        <AthletesContainer />
      </FiltersProvider>
      <Footer />
    </>
  );
};

export default withApollo(Athletes, { getDataFromTree });
